//const API_URI = "https://localhost:5001/";
const API_URI = "https://www.linemp3.com/api/";
const SERVICE_URI = "https://www.linemp3.com/";

export default {
    API_URI,
    SERVICE_URI,
};
